<ion-back-button
        [defaultHref]="defaultHref"
        icon=""
        [text]="'lbl_go_back' | translate"
>

</ion-back-button>
